import React, { Component } from 'react';
import Flatpickr from 'react-flatpickr'
var ReactSuperSelect = require('react-super-select');
const moment = require('moment');

class HRTSurvey extends Component {
	constructor(props) {
		super(props);
		this.state = {
			active: false,
			selectedSection: 'SurveySettings',
			addingSetting: false,
			editBox: false,
			addBox: false,
			loading: false,
			filterBy: {}
		};
	}

	checkState = (option) => {
		console.log(this.state);
	}

	showEditBox = (desc, data) => e => {
		console.log('showEditBox');

		this.setState({
			editBox: desc,
			selectedObject: data,
			originalObject: data,
			loading: false
		})
		console.log(this.state);
	}

	showAddBox = (type) => e => {
		var data = {}

		if (type === 'SurveyQuestions') {
			data = {
				SurveyNumber: '',
				SurveyQuestionEnglish: '',
				SurveyQuestionSpanish: '',
				SurveyOption1: '',
				SurveyOption2: '',
				SurveyOption3: '',
				SurveyOption4: '',
				SurveyOption5: '',
				SurveyActive: false
			}
		}

		this.setState({
			addBox: type,
			setting: {},
			loading: false,
			selectedObject: data,
			originalObject: data
		})
	}

	showDeleteBox = (type, data) => e => {
		e.stopPropagation()
		this.setState({ deleteBox: type, selectedObject: data, loading: false })
	}

	editDate = (desc, data) => e => {
		console.log('data');
	}

	editParam = (param) => (e) => {
		console.log('editParam')

		var newSetting = Object.assign({}, this.state.selectedObject)
		newSetting[param] = e.target.value
		this.setState({ selectedObject: newSetting, loading: false })

		console.log(this.state);
	}

	toggle = (param) => (e) => {
		console.log('toggle')
		var newSetting = Object.assign({}, this.state.selectedObject)
		newSetting[param] = this.state.selectedObject[param] ? false : true
		this.setState({ selectedObject: newSetting, loading: false })
	}

	cancel = () => {
		console.log('cancel');
		this.setState({
			editBox: false,
			addBox: false,
			deleteBox: false,
			addingSetting: false,
			loading: false,
			selectedObject: false,
			originalObject: false,
			error: false
		})

		console.log(this.state);
	}

	toggleSection = (option) => {
		if (option) {
			this.setState({ selectedSection: option.id, error: '' });
		}
	}

	confirmChanges = (type, data) => (e) => {
		if (type === 'InvitationQuestions') {
			if (data.InvitationQuestionEnglish.length < 1) {
				this.setState({ error: 'Please enter verbiage for Invitation Question English' })
			} else if (data.InvitationQuestionSpanish.length < 1) {
				this.setState({ error: 'Please enter verbiage for Invitation Question Spanish' })
			} else if (new Date(data.InvitationStart) > new Date(data.InvitationEnd)) {
				this.setState({ error: 'End date must not be before start date.' })
			} else {
				this.setState({
					error: false,
					loading: true
				})
				this.props.ws.send(JSON.stringify({ route: 'editInvitationQuestions', setting: data }))

				console.log('will save ' + type + ':');
				console.log(data);
			}

		} else if (type === 'DaysBetweenSurvey') {

			if (data.DaysBetweenSurvey < 0 || data.DaysBetweenSurvey > 365) {
				this.setState({ error: 'Value must be between 0 and 365.' })
			} else {
				this.setState({
					error: false,
					loading: true
				})
				this.props.ws.send(JSON.stringify({ route: 'editDaysBetweenSurvey', setting: data }))

				console.log('will save ' + type + ':');
				console.log(data);
			}
		} else if (type === 'SurveyQuestions') {
			if (data.SurveyQuestionEnglish.length < 1) {
				this.setState({ error: 'Please enter verbiage for Survey Question English' })
			} else if (data.SurveyQuestionSpanish.length < 1) {
				this.setState({ error: 'Please enter verbiage for Survey Question Spanish' })
			} else if (data.SurveyOption1.length < 1) {
				this.setState({ error: 'Please enter a description for Survey Option 1' })
			} else if (data.SurveyOption2.length < 1) {
				this.setState({ error: 'Please enter a description for Survey Option 2' })
			} else if (data.SurveyOption3.length < 1) {
				this.setState({ error: 'Please enter a description for Survey Option 3' })
			} else if (data.SurveyOption4.length < 1) {
				this.setState({ error: 'Please enter a description for Survey Option 4' })
			} else if (data.SurveyOption5.length < 1) {
				this.setState({ error: 'Please enter a description for Survey Option 5' })
			} else {
				var oldData = this.state.originalObject

				//if this is a new entry or if an edit triggers a new entry
				if (!data.SurveyID || data.SurveyQuestionDescription != oldData.SurveyQuestionDescription || data.SurveyNumber != oldData.SurveyNumber || data.SurveyQuestionEnglish != oldData.SurveyQuestionEnglish || data.SurveyQuestionSpanish != oldData.SurveyQuestionSpanish || data.SurveyOption1 != oldData.SurveyOption1 || data.SurveyOption2 != oldData.SurveyOption2 || data.SurveyOption3 != oldData.SurveyOption3 || data.SurveyOption4 != oldData.SurveyOption4 || data.SurveyOption5 != oldData.SurveyOption5) {
					this.setState({
						error: false,
						loading: true
					})

					if (!data.SurveyID) {
						if (this.state.selectedSection === 'SurveyQuestions') {
							data.SurveyNumber = 1;
						}
					}

					data.SurveyDatetimeCreated = new Date().toISOString();
					console.log('datetime updated');

					console.log('data iiiiis...')
					console.log(data);
					this.props.ws.send(JSON.stringify({ route: 'addSurveyQuestions', setting: data }))


					if (oldData.SurveyID) {
						console.log('disable old survey question');
						oldData.SurveyActive = false;
						console.log(oldData);
						this.props.ws.send(JSON.stringify({ route: 'editSurveyQuestions', setting: oldData }))
					}

				} else {	//otherwise we can edit an existing entry.  The only thing that can be edited is making the active option true/false.
					this.setState({
						error: false,
						loading: true
					})
					this.props.ws.send(JSON.stringify({ route: 'editSurveyQuestions', setting: data }))
					console.log('data is...')
					console.log(data);
				}
				console.log('will save ' + type + ':');
				console.log(data);
			}

		}
	}

	confirmDelete = (type, data) => e => {
		this.setState({ loading: true });
		this.props.ws.send(JSON.stringify({ route: 'delete' + type, setting: data }))
	}
	/*
		confirmAdd = (type, data) => e => {
			if (type === 'SurveyQuestions') {
				if (data.SurveyNumber != '1' && data.SurveyNumber != '2') {
					this.setState({ error:  'Survey Number must be 1 or 2.'})
				} else if (data.SurveyQuestionDescription.length < 1) {
					this.setState({ error:  'Please enter a Survey Question Description'})
				} else if (data.SurveyQuestionEnglish.length < 1) {
					this.setState({ error:  'Please enter verbiage for Survey Question English'})
				} else if (data.SurveyQuestionSpanish.length < 1) {
					this.setState({ error:  'Please enter verbiage for Survey Question Spanish'})
				} else if (data.SurveyOption1.length < 1) {
					this.setState({ error:  'Please enter a description for Survey Option 1'})
				} else if (data.SurveyOption2.length < 1) {
					this.setState({ error:  'Please enter a description for Survey Option 2'})
				} else if (data.SurveyOption3.length < 1) {
					this.setState({ error:  'Please enter a description for Survey Option 3'})
				} else if (data.SurveyOption4.length < 1) {
					this.setState({ error:  'Please enter a description for Survey Option 4'})
				} else if (data.SurveyOption5.length < 1) {
					this.setState({ error:  'Please enter a description for Survey Option 5'})
				} else {
					this.setState({
						error: false,
						loading: true
					})
	
					this.props.ws.send(JSON.stringify({ route: 'addSurveyQuestions', setting: data }))
	
					console.log('will save ' + type + ':');
					console.log (data);
				}
			}
		}
	*/

	sortFunc(sortBy, sortOrder) {
		return function (a, b) {
			if (sortBy === 'dateRange') {
				return new Date(a.StartDateTime).getTime() > new Date(b.StartDateTime).getTime() ? 1 * sortOrder : -1 * sortOrder
			}
			if (sortBy in a && sortBy in b) {
				if (a[sortBy] === b[sortBy]) {
					return a.ID > b.ID ? 1 * sortOrder : -1 * sortOrder
				}
				return a[sortBy] > b[sortBy] ? 1 * sortOrder : -1 * sortOrder
			} else if (!(sortBy in a) && !(sortBy in b)) {
				return a.ID > b.ID ? 1 * sortOrder : -1 * sortOrder
			} else {

				return sortBy in a ? -1 : 1
			}
		}
	}

	componentWillReceiveProps(nextProps) {
		if (this.state.loading) {
			this.cancel();
		}
	}

	render() {
		if (this.props.active) {
			var contentMain, contentEditBox

			if (this.state.selectedSection === 'SurveySettings') {
				contentMain = []
				contentMain.push(
					<div>
						<div className="viewHeader">
							<h1>Invitations</h1>
						</div>
						<div className="dataHeaders">
							<span style={{ flex: '0 0 75px', cursor: 'pointer' }}>Active</span>
							<span style={{ flex: '1 0 20%', cursor: 'pointer' }}>Invitation Number</span>
							<span style={{ flex: '1 0 30%', cursor: 'pointer' }}>Date/Time Range</span>
						</div>
					</div>
				)

				for (var survey of this.props.data.HRTSurvey.InvitationQuestions) {
					var startDate = moment(survey.InvitationStart).format('MM/DD/YYYY h:mm:ss a');
					var endDate = moment(survey.InvitationEnd).format('MM/DD/YYYY h:mm:ss a');

					contentMain.push(
						<div className="dataRow" key={survey.InvitationNumber} onClick={this.showEditBox('InvitationQuestions', survey)}>
							<div className="activeBox">
								<div className={survey.InvitationActive ? "enabled" : "disabled"}></div>
							</div>
							<span style={{ flex: '1 0 20%', textAlign: 'center' }}>Invitation {survey.InvitationNumber}</span>
							<span style={{ flex: '1 0 30%', textAlign: 'center' }}>{startDate} to {endDate}</span>
						</div>
					)
				}

				contentMain.push(
					<div>
						<div className="viewHeader">
							<h1>Days Between Survey</h1>
						</div>
						<div className="dataRow" onClick={this.showEditBox('DaysBetweenSurvey', { DaysBetweenSurvey: this.props.data.HRTSurvey.DaysBetweenSurvey })}>
							<span style={{ flex: '1 0 100%', textAlign: 'center' }}>{this.props.data.HRTSurvey.DaysBetweenSurvey} Days Between Surveys</span>
						</div>
					</div>
				)

				if (this.state.editBox === 'InvitationQuestions') {
					contentEditBox = (
						<div className="blackout" tabIndex="1" autoFocus >
							<div className="pop">
								<div className="viewCloser" onClick={this.cancel}></div>
								<div>You Are Editing Invitation Question {this.state.selectedObject.InvitationNumber}</div>
								<br />

								<div className="snazzyInputBox">
									<textarea className="bigTextInput" required value={this.state.selectedObject.InvitationQuestionEnglish} onChange={this.editParam('InvitationQuestionEnglish')} ></textarea>
									<label className="textLabel">Invitation Question English</label>
									<div style={{ color: this.state.selectedObject.InvitationQuestionEnglish.length > 500 ? '#937' : '', textAlign: 'right', paddingRight: '15px', top: '-15px', fontSize: '14px', position: 'relative' }}>{this.state.selectedObject.InvitationQuestionEnglish.length}/500</div>
								</div>

								<div className="snazzyInputBox">
									<textarea className="bigTextInput" required value={this.state.selectedObject.InvitationQuestionSpanish} onChange={this.editParam('InvitationQuestionSpanish')} ></textarea>
									<label className="textLabel">Invitation Question Spanish</label>
									<div style={{ color: this.state.selectedObject.InvitationQuestionSpanish.length > 500 ? '#937' : '', textAlign: 'right', paddingRight: '15px', top: '-15px', fontSize: '14px', position: 'relative' }}>{this.state.selectedObject.InvitationQuestionSpanish.length}/500</div>
								</div>

								<div style={{ display: 'inline-block' }}>
									<div>Start</div>
									<Flatpickr style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }} options={{ dateFormat: "Y-m-d h:i K" }} data-enable-time value={this.state.selectedObject.InvitationStart} onChange={date => { this.setState({ selectedObject: { ...this.state.selectedObject, InvitationStart: date[0] } }); console.log(this.state) }} />
								</div>
								<div style={{ display: 'inline-block' }}>
									<div>End</div>
									<Flatpickr style={{ border: '1px solid #2A6AA9', padding: '15px', width: '130px', margin: '5px' }} options={{ dateFormat: "Y-m-d h:i K" }} data-enable-time value={this.state.selectedObject.InvitationEnd} onChange={date => { this.setState({ selectedObject: { ...this.state.selectedObject, InvitationEnd: date[0] } }); console.log(this.state) }} />
								</div>

								<div style={{ paddingTop: '25px', display: 'flex', justifyContent: 'space-around' }}>
									<div >
										<div>Active</div>
										<div className="activeBox" onClick={this.toggle('InvitationActive')}>
											<div className={this.state.selectedObject.InvitationActive ? "enabled" : "disabled"}></div>
										</div>
									</div>
								</div>

								<div className="error" style={{ padding: '15px' }}>{this.state.error}</div>

								{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmChanges('InvitationQuestions', this.state.selectedObject)}>Confirm</div>}
							</div>
						</div>
					)
				} else if (this.state.editBox === 'DaysBetweenSurvey') {
					contentEditBox = (
						<div className="blackout" tabIndex="1" autoFocus >
							<div className="pop" >
								<div className="viewCloser" onClick={this.cancel}></div>
								<div className="snazzyInputBox">
									<input className="textInput" type="number" required value={this.state.selectedObject.DaysBetweenSurvey} onChange={this.editParam('DaysBetweenSurvey')} ></input>
									<span className="inputBar"></span><label className="textLabel">Days Between Survey</label>
								</div>

								<div className="error" style={{ padding: '15px' }}>{this.state.error}</div>

								{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmChanges('DaysBetweenSurvey', this.state.selectedObject)}>Confirm</div>}
							</div>
						</div>
					)
				}

			} else if (this.state.selectedSection === 'SurveyQuestions') {
				contentMain = [];
				contentMain.push(<img src={this.props.img.plus} className="plusButton" alt="Add A Question" onClick={this.showAddBox('SurveyQuestions')} />);

				contentMain.push(
					<div>
						<div className="viewHeader">
							<h1>Survey Questions</h1>
						</div>
						<div className="dataHeaders">
							<span style={{ flex: '0 0 75px', cursor: 'pointer' }}>Active</span>
							<span style={{ flex: '1 0 20%', cursor: 'pointer' }}>Question Description</span>
							<span style={{ flex: '1 0 30%', cursor: 'pointer' }}>Date Created</span>
						</div>
					</div>
				)

				//sort by date created for this table, oldest on bottom
				var questions = this.props.data.HRTSurvey.SurveyQuestions.slice()
				questions.sort(this.sortFunc('SurveyDatetimeCreated', 1))

				for (var question of questions) {
					var datetimeCreated = moment(question.SurveyDatetimeCreated).format('MM/DD/YYYY h:mm:ss a');

					if (question.SurveyNumber === 1) {
						contentMain.push(
							<div className="dataRow" key={question.SurveyID} onClick={this.showEditBox('SurveyQuestions', question)}>
								<div className="activeBox">
									<div className={question.SurveyActive ? "enabled" : "disabled"}></div>
								</div>
								<span style={{ flex: '1 0 20%', textAlign: 'center' }}>{question.SurveyQuestionDescription}</span>
								<span style={{ flex: '1 0 30%', textAlign: 'center' }}>{datetimeCreated}</span>
								<span className="buttonBox" style={{ flex: '0 0 50px' }}>
									<img src={this.props.img.delete} alt="Delete Question" onClick={this.showDeleteBox('SurveyQuestions', question)} />
								</span>
							</div>
						)
					}
				}

				if (this.state.editBox === 'SurveyQuestions') {
					contentEditBox = (
						<div className="blackout" tabIndex="1" autoFocus >
							<div className="pop">
								<div className="viewCloser" onClick={this.cancel}></div>
								<div>You Are Editing Survey Question: {this.state.selectedObject.SurveyQuestionDescription}</div>
								<br />

								<div className="snazzyInputBox">
									<input className="textInput" type="text" required value={this.state.selectedObject.SurveyQuestionDescription} onChange={this.editParam('SurveyQuestionDescription')} ></input>
									<span className="inputBar"></span><label className="textLabel">Survey Question Description</label>
								</div>

								<div className="snazzyInputBox">
									<textarea className="bigTextInput" required value={this.state.selectedObject.SurveyQuestionEnglish} onChange={this.editParam('SurveyQuestionEnglish')} ></textarea>
									<label className="textLabel">Survey Question English</label>
									<div style={{ color: this.state.selectedObject.SurveyQuestionEnglish.length > 500 ? '#937' : '', textAlign: 'right', paddingRight: '15px', top: '-15px', fontSize: '14px', position: 'relative' }}>{this.state.selectedObject.SurveyQuestionEnglish.length}/500</div>
								</div>

								<div className="snazzyInputBox">
									<textarea className="bigTextInput" required value={this.state.selectedObject.SurveyQuestionSpanish} onChange={this.editParam('SurveyQuestionSpanish')} ></textarea>
									<label className="textLabel">Survey Question Spanish</label>
									<div style={{ color: this.state.selectedObject.SurveyQuestionSpanish.length > 500 ? '#937' : '', textAlign: 'right', paddingRight: '15px', top: '-15px', fontSize: '14px', position: 'relative' }}>{this.state.selectedObject.SurveyQuestionSpanish.length}/500</div>
								</div>

								<div className="snazzyInputBox">
									<input className="textInput" type="text" required value={this.state.selectedObject.SurveyOption1} onChange={this.editParam('SurveyOption1')} ></input>
									<span className="inputBar"></span><label className="textLabel">Survey Option 1</label>
								</div>

								<div className="snazzyInputBox">
									<input className="textInput" type="text" required value={this.state.selectedObject.SurveyOption2} onChange={this.editParam('SurveyOption2')} ></input>
									<span className="inputBar"></span><label className="textLabel">Survey Option 2</label>
								</div>

								<div className="snazzyInputBox">
									<input className="textInput" type="text" required value={this.state.selectedObject.SurveyOption3} onChange={this.editParam('SurveyOption3')} ></input>
									<span className="inputBar"></span><label className="textLabel">Survey Option 3</label>
								</div>

								<div className="snazzyInputBox">
									<input className="textInput" type="text" required value={this.state.selectedObject.SurveyOption4} onChange={this.editParam('SurveyOption4')} ></input>
									<span className="inputBar"></span><label className="textLabel">Survey Option 4</label>
								</div>

								<div className="snazzyInputBox">
									<input className="textInput" type="text" required value={this.state.selectedObject.SurveyOption5} onChange={this.editParam('SurveyOption5')} ></input>
									<span className="inputBar"></span><label className="textLabel">Survey Option 5</label>
								</div>

								<div style={{ paddingTop: '25px', display: 'flex', justifyContent: 'space-around' }}>
									<div >
										<div>Active</div>
										<div className="activeBox" onClick={this.toggle('SurveyActive')}>
											<div className={this.state.selectedObject.SurveyActive ? "enabled" : "disabled"}></div>
										</div>
									</div>
								</div>

								<div className="error" style={{ padding: '15px' }}>{this.state.error}</div>

								{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmChanges('SurveyQuestions', this.state.selectedObject)}>Confirm</div>}
							</div>
						</div>
					)
				} else if (this.state.addBox === 'SurveyQuestions') {
					contentEditBox = (
						<div className="blackout" tabIndex="1" autoFocus >
							<div className="pop">
								<div className="viewCloser" onClick={this.cancel}></div>
								<div>You Are Adding A New Survey Question</div>
								<br />

								<div className="snazzyInputBox">
									<input className="textInput" type="text" required onChange={this.editParam('SurveyQuestionDescription')} ></input>
									<span className="inputBar"></span><label className="textLabel">Survey Question Description</label>
								</div>

								<div className="snazzyInputBox">
									<textarea className="bigTextInput" required onChange={this.editParam('SurveyQuestionEnglish')} ></textarea>
									<label className="textLabel">Survey Question English</label>
									<div style={{ color: this.state.selectedObject.SurveyQuestionEnglish.length > 500 ? '#937' : '', textAlign: 'right', paddingRight: '15px', top: '-15px', fontSize: '14px', position: 'relative' }}>{this.state.selectedObject.SurveyQuestionEnglish.length}/500</div>
								</div>

								<div className="snazzyInputBox">
									<textarea className="bigTextInput" required onChange={this.editParam('SurveyQuestionSpanish')} ></textarea>
									<label className="textLabel">Survey Question Spanish</label>
									<div style={{ color: this.state.selectedObject.SurveyQuestionSpanish.length > 500 ? '#937' : '', textAlign: 'right', paddingRight: '15px', top: '-15px', fontSize: '14px', position: 'relative' }}>{this.state.selectedObject.SurveyQuestionSpanish.length}/500</div>
								</div>

								<div className="snazzyInputBox">
									<input className="textInput" type="text" required onChange={this.editParam('SurveyOption1')} ></input>
									<span className="inputBar"></span><label className="textLabel">Survey Option 1</label>
								</div>

								<div className="snazzyInputBox">
									<input className="textInput" type="text" required onChange={this.editParam('SurveyOption2')} ></input>
									<span className="inputBar"></span><label className="textLabel">Survey Option 2</label>
								</div>

								<div className="snazzyInputBox">
									<input className="textInput" type="text" required onChange={this.editParam('SurveyOption3')} ></input>
									<span className="inputBar"></span><label className="textLabel">Survey Option 3</label>
								</div>

								<div className="snazzyInputBox">
									<input className="textInput" type="text" required onChange={this.editParam('SurveyOption4')} ></input>
									<span className="inputBar"></span><label className="textLabel">Survey Option 4</label>
								</div>

								<div className="snazzyInputBox">
									<input className="textInput" type="text" required onChange={this.editParam('SurveyOption5')} ></input>
									<span className="inputBar"></span><label className="textLabel">Survey Option 5</label>
								</div>

								<div style={{ paddingTop: '25px', display: 'flex', justifyContent: 'space-around' }}>
									<div >
										<div>Active</div>
										<div className="activeBox" onClick={this.toggle('SurveyActive')}>
											<div className={this.state.selectedObject.SurveyActive ? "enabled" : "disabled"}></div>
										</div>
									</div>
								</div>

								<div className="error" style={{ padding: '15px' }}>{this.state.error}</div>

								{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmChanges('SurveyQuestions', this.state.selectedObject)}>Confirm</div>}
							</div>
						</div>
					)
				} else if (this.state.deleteBox == 'SurveyQuestions') {
					contentEditBox = (
						<div className="blackout" tabIndex="1" autoFocus>
							<div className="pop" >
								<div className="viewCloser" onClick={this.cancel}></div>
								<div style={{ textAlign: 'center' }}>You are removing this survey question:</div>
								<div style={{ textAlign: 'center' }}>{this.state.selectedObject.SurveyQuestionDescription}</div>
								<br />

								{this.state.loading ? <div className="loader"></div> : <div className="button" onClick={this.confirmDelete('SurveyQuestions', this.state.selectedObject)}>Delete Question</div>}
							</div>
						</div>
					)
				}
			}

			return (
				<div className="viewContent" id="reportView" >
					<div style={{ display: 'flex' }}>
						<ReactSuperSelect style={{ flex: '1 0 150px', margin: '0px', display: 'inline-block' }} onChange={this.toggleSection} initialValue={{ id: 'SurveySettings', name: 'Survey Settings' }} placeholder={"Settings Group"} clearable={false} closeOnSelectedOptionClick={false} dataSource={[{ id: 'SurveySettings', name: 'Survey Settings' }, { id: 'SurveyQuestions', name: 'Survey Questions' }]} />
					</div>

					<div style={{ overflow: 'auto', height: 'calc(100% - 45px)' }}>
						{contentMain}
					</div>
					{contentEditBox}
				</div>
			);
		} else {
			return (
				<div width="100%">

				</div>
			);
		}
	}
}



const icon = "menuConverse"
const roles = ["View"]
export { HRTSurvey, icon, roles }



// WEBPACK FOOTER //
// ./src/Views/HRTSurvey.js